export default "__VITE_ASSET__e9e8cdcf__"